"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApiMedicationObject = _interopRequireDefault(require("./ApiMedicationObject"));
var _ApiPainConditionObject = _interopRequireDefault(require("./ApiPainConditionObject"));
var _UserProfileRecordAllOfContentAvatar = _interopRequireDefault(require("./UserProfileRecordAllOfContentAvatar"));
var _UserProfileRecordAllOfContentProviders = _interopRequireDefault(require("./UserProfileRecordAllOfContentProviders"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The UserProfileRecordAllOfContent model module.
 * @module model/UserProfileRecordAllOfContent
 * @version 4.0.0
 */
var UserProfileRecordAllOfContent = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>UserProfileRecordAllOfContent</code>.
   * @alias module:model/UserProfileRecordAllOfContent
   */
  function UserProfileRecordAllOfContent() {
    _classCallCheck(this, UserProfileRecordAllOfContent);
    UserProfileRecordAllOfContent.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(UserProfileRecordAllOfContent, null, [{
    key: "initialize",
    value: function initialize(obj) {
      obj['height_units'] = 'c';
      obj['weight_units'] = 'k';
    }

    /**
     * Constructs a <code>UserProfileRecordAllOfContent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserProfileRecordAllOfContent} obj Optional instance to populate.
     * @return {module:model/UserProfileRecordAllOfContent} The populated <code>UserProfileRecordAllOfContent</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new UserProfileRecordAllOfContent();
        if (data.hasOwnProperty('birth_date')) {
          obj['birth_date'] = _ApiClient["default"].convertToType(data['birth_date'], 'String');
        }
        if (data.hasOwnProperty('country')) {
          obj['country'] = _ApiClient["default"].convertToType(data['country'], 'String');
        }
        if (data.hasOwnProperty('credits_count')) {
          obj['credits_count'] = _ApiClient["default"].convertToType(data['credits_count'], 'Number');
        }
        if (data.hasOwnProperty('encryption_key')) {
          obj['encryption_key'] = _ApiClient["default"].convertToType(data['encryption_key'], 'String');
        }
        if (data.hasOwnProperty('gender')) {
          obj['gender'] = _ApiClient["default"].convertToType(data['gender'], 'String');
        }
        if (data.hasOwnProperty('height')) {
          obj['height'] = _ApiClient["default"].convertToType(data['height'], 'Number');
        }
        if (data.hasOwnProperty('height_units')) {
          obj['height_units'] = _ApiClient["default"].convertToType(data['height_units'], 'String');
        }
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('display_name')) {
          obj['display_name'] = _ApiClient["default"].convertToType(data['display_name'], 'String');
        }
        if (data.hasOwnProperty('weight')) {
          obj['weight'] = _ApiClient["default"].convertToType(data['weight'], 'Number');
        }
        if (data.hasOwnProperty('weight_units')) {
          obj['weight_units'] = _ApiClient["default"].convertToType(data['weight_units'], 'String');
        }
        if (data.hasOwnProperty('android_lite_rated')) {
          obj['android_lite_rated'] = _ApiClient["default"].convertToType(data['android_lite_rated'], 'Number');
        }
        if (data.hasOwnProperty('android_pro_rated')) {
          obj['android_pro_rated'] = _ApiClient["default"].convertToType(data['android_pro_rated'], 'Number');
        }
        if (data.hasOwnProperty('android_rn_rated')) {
          obj['android_rn_rated'] = _ApiClient["default"].convertToType(data['android_rn_rated'], 'Number');
        }
        if (data.hasOwnProperty('apple_rn_rated')) {
          obj['apple_rn_rated'] = _ApiClient["default"].convertToType(data['apple_rn_rated'], 'Number');
        }
        if (data.hasOwnProperty('medications')) {
          obj['medications'] = _ApiClient["default"].convertToType(data['medications'], [_ApiMedicationObject["default"]]);
        }
        if (data.hasOwnProperty('condition')) {
          obj['condition'] = _ApiClient["default"].convertToType(data['condition'], [_ApiPainConditionObject["default"]]);
        }
        if (data.hasOwnProperty('providers')) {
          obj['providers'] = _UserProfileRecordAllOfContentProviders["default"].constructFromObject(data['providers']);
        }
        if (data.hasOwnProperty('avatar')) {
          obj['avatar'] = _UserProfileRecordAllOfContentAvatar["default"].constructFromObject(data['avatar']);
        }
        if (data.hasOwnProperty('eula_version')) {
          obj['eula_version'] = _ApiClient["default"].convertToType(data['eula_version'], 'Number');
        }
        if (data.hasOwnProperty('privacy_notice_version')) {
          obj['privacy_notice_version'] = _ApiClient["default"].convertToType(data['privacy_notice_version'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserProfileRecordAllOfContent</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserProfileRecordAllOfContent</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['birth_date'] && !(typeof data['birth_date'] === 'string' || data['birth_date'] instanceof String)) {
        throw new Error("Expected the field `birth_date` to be a primitive type in the JSON string but got " + data['birth_date']);
      }
      // ensure the json data is a string
      if (data['country'] && !(typeof data['country'] === 'string' || data['country'] instanceof String)) {
        throw new Error("Expected the field `country` to be a primitive type in the JSON string but got " + data['country']);
      }
      // ensure the json data is a string
      if (data['encryption_key'] && !(typeof data['encryption_key'] === 'string' || data['encryption_key'] instanceof String)) {
        throw new Error("Expected the field `encryption_key` to be a primitive type in the JSON string but got " + data['encryption_key']);
      }
      // ensure the json data is a string
      if (data['gender'] && !(typeof data['gender'] === 'string' || data['gender'] instanceof String)) {
        throw new Error("Expected the field `gender` to be a primitive type in the JSON string but got " + data['gender']);
      }
      // ensure the json data is a string
      if (data['height_units'] && !(typeof data['height_units'] === 'string' || data['height_units'] instanceof String)) {
        throw new Error("Expected the field `height_units` to be a primitive type in the JSON string but got " + data['height_units']);
      }
      // ensure the json data is a string
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['display_name'] && !(typeof data['display_name'] === 'string' || data['display_name'] instanceof String)) {
        throw new Error("Expected the field `display_name` to be a primitive type in the JSON string but got " + data['display_name']);
      }
      // ensure the json data is a string
      if (data['weight_units'] && !(typeof data['weight_units'] === 'string' || data['weight_units'] instanceof String)) {
        throw new Error("Expected the field `weight_units` to be a primitive type in the JSON string but got " + data['weight_units']);
      }
      if (data['medications']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['medications'])) {
          throw new Error("Expected the field `medications` to be an array in the JSON data but got " + data['medications']);
        }
        // validate the optional field `medications` (array)
        var _iterator = _createForOfIteratorHelper(data['medications']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _ApiMedicationObject["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['condition']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['condition'])) {
          throw new Error("Expected the field `condition` to be an array in the JSON data but got " + data['condition']);
        }
        // validate the optional field `condition` (array)
        var _iterator2 = _createForOfIteratorHelper(data['condition']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _ApiPainConditionObject["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      // validate the optional field `providers`
      if (data['providers']) {
        // data not null
        _UserProfileRecordAllOfContentProviders["default"].validateJSON(data['providers']);
      }
      // validate the optional field `avatar`
      if (data['avatar']) {
        // data not null
        _UserProfileRecordAllOfContentAvatar["default"].validateJSON(data['avatar']);
      }
      return true;
    }
  }]);
}();
/**
 * An English string representation of birth date in the form of \"dd-mmm-yyyy\".
 * @member {String} birth_date
 */
UserProfileRecordAllOfContent.prototype['birth_date'] = undefined;

/**
 * Country of residence for the user. The parameter follows the two-letter country code as defined by [ISO 3166-1](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
 * @member {String} country
 */
UserProfileRecordAllOfContent.prototype['country'] = undefined;

/**
 * The number of credits a user has for generating \"Advanced\" reports.
 * @member {Number} credits_count
 */
UserProfileRecordAllOfContent.prototype['credits_count'] = undefined;

/**
 * A server-generated key that is used to encrypt and decrypt databases that are stored locally on the user's device.  As a result, any backup created by a logged-in user will encrypted using this key, and can only be restored by the same logged-in user.
 * @member {String} encryption_key
 */
UserProfileRecordAllOfContent.prototype['encryption_key'] = undefined;

/**
 * Available options for gender are Male ('m'), Female ('f'), or Other ('o').  But if other is selected, then the user can enter additional detail (e.g. Transgender) - entered value will be sent to the server as-is instead of option 'o'.
 * @member {module:model/UserProfileRecordAllOfContent.GenderEnum} gender
 */
UserProfileRecordAllOfContent.prototype['gender'] = undefined;

/**
 * User-defined height in centimeters, regardless of 'height_units'.
 * @member {Number} height
 */
UserProfileRecordAllOfContent.prototype['height'] = undefined;

/**
 * User's preferred unit to display height. Available height units are centimeters (c) and feet/inches (i).
 * @member {module:model/UserProfileRecordAllOfContent.HeightUnitsEnum} height_units
 * @default 'c'
 */
UserProfileRecordAllOfContent.prototype['height_units'] = 'c';

/**
 * User-defined name used in the About Me section of the User Profile.
 * @member {String} name
 */
UserProfileRecordAllOfContent.prototype['name'] = undefined;

/**
 * User-defined name used for public display purposes only (e.g. institution portal admin list, forums).  It should default to the 'name' value.
 * @member {String} display_name
 */
UserProfileRecordAllOfContent.prototype['display_name'] = undefined;

/**
 * User-defined weight in kilograms, regardless of 'weight_units'.
 * @member {Number} weight
 */
UserProfileRecordAllOfContent.prototype['weight'] = undefined;

/**
 * User's preferred unit to display height. Available weight units are kilograms (k), pounds (p) and stones (s)
 * @member {module:model/UserProfileRecordAllOfContent.WeightUnitsEnum} weight_units
 * @default 'k'
 */
UserProfileRecordAllOfContent.prototype['weight_units'] = 'k';

/**
 * A flag that determines if a user has rated Manage My Pain Lite for Android.
 * @member {Number} android_lite_rated
 */
UserProfileRecordAllOfContent.prototype['android_lite_rated'] = undefined;

/**
 * A flag that determines if a user has rated Manage My Pain Pro for Android.
 * @member {Number} android_pro_rated
 */
UserProfileRecordAllOfContent.prototype['android_pro_rated'] = undefined;

/**
 * A flag that determines if a user has rated React Native version of the app for Android.
 * @member {Number} android_rn_rated
 */
UserProfileRecordAllOfContent.prototype['android_rn_rated'] = undefined;

/**
 * A flag that determines if a user has rated React Native version of the app for iOS.
 * @member {Number} apple_rn_rated
 */
UserProfileRecordAllOfContent.prototype['apple_rn_rated'] = undefined;

/**
 * @member {Array.<module:model/ApiMedicationObject>} medications
 */
UserProfileRecordAllOfContent.prototype['medications'] = undefined;

/**
 * @member {Array.<module:model/ApiPainConditionObject>} condition
 */
UserProfileRecordAllOfContent.prototype['condition'] = undefined;

/**
 * @member {module:model/UserProfileRecordAllOfContentProviders} providers
 */
UserProfileRecordAllOfContent.prototype['providers'] = undefined;

/**
 * @member {module:model/UserProfileRecordAllOfContentAvatar} avatar
 */
UserProfileRecordAllOfContent.prototype['avatar'] = undefined;

/**
 * Optional parameter. EULA version accepted by user. It can't be changed to lower version
 * @member {Number} eula_version
 */
UserProfileRecordAllOfContent.prototype['eula_version'] = undefined;

/**
 * Optional parameter. Privacy Notice version accepted by user. It can't be changed to lower version
 * @member {Number} privacy_notice_version
 */
UserProfileRecordAllOfContent.prototype['privacy_notice_version'] = undefined;

/**
 * Allowed values for the <code>gender</code> property.
 * @enum {String}
 * @readonly
 */
UserProfileRecordAllOfContent['GenderEnum'] = {
  /**
   * value: "f"
   * @const
   */
  "f": "f",
  /**
   * value: "m"
   * @const
   */
  "m": "m",
  /**
   * value: "o"
   * @const
   */
  "o": "o"
};

/**
 * Allowed values for the <code>height_units</code> property.
 * @enum {String}
 * @readonly
 */
UserProfileRecordAllOfContent['HeightUnitsEnum'] = {
  /**
   * value: "c"
   * @const
   */
  "c": "c",
  /**
   * value: "i"
   * @const
   */
  "i": "i"
};

/**
 * Allowed values for the <code>weight_units</code> property.
 * @enum {String}
 * @readonly
 */
UserProfileRecordAllOfContent['WeightUnitsEnum'] = {
  /**
   * value: "k"
   * @const
   */
  "k": "k",
  /**
   * value: "p"
   * @const
   */
  "p": "p",
  /**
   * value: "s"
   * @const
   */
  "s": "s"
};
var _default = exports["default"] = UserProfileRecordAllOfContent;